module.exports = "<div class=\"wrapper wrapper-content animated fadeIn\" id=import> <div class=row> <div class=col-lg-12> <div class=ibox-content> <div ui-view></div> </div> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// .-dna/app/subsections/financial-events/inspect.financial-events.html
// module id = 4161
// module chunks = 86